import { BuildingTypeResponse } from "@/web-client/api";
import { SearchQueryParameterController } from "@/hooks/useSearchQueryParameter";
import { useCallback, useMemo } from "react";
import { FC, useState } from "react";
import { ArchitectureSearchQueryParameter } from "@/types/ArchitectureSearchQueryParameter";
import SearchDropdownButton from "@/components/SearchDropdownButton";
import EntityDrillDown, { DrillDownCell } from "@/components/EntityDrillDown";
import useAllUseTypes from "@/hooks/useAllUseTypes";

interface Props {
  buildingTypes: BuildingTypeResponse[];
  query: ArchitectureSearchQueryParameter;
  queryController: SearchQueryParameterController<ArchitectureSearchQueryParameter>;
  onOpenModal: () => void;
}

enum ArchitectureDropdown {
  None = -1,
  BuildingType = 1,
  UseType = 2,
}

const SearchArchitectureDropdowns: FC<Props> = ({
  buildingTypes,
  query,
  queryController,
  onOpenModal,
}): JSX.Element => {
  const [select, setSelect] = useState(ArchitectureDropdown.None);

  const isBuildingType = useMemo(
    () => select === ArchitectureDropdown.BuildingType,
    [select],
  );

  const isUseType = useMemo(
    () => select === ArchitectureDropdown.UseType,
    [select],
  );

  const closeHandler = useCallback(
    () => setSelect(ArchitectureDropdown.None),
    [setSelect],
  );

  const allUseTypes = useAllUseTypes();

  return (
    <div>
      <div className="grid grid-cols-3 [&>*+*]:border-l">
        <SearchDropdownButton
          active={isBuildingType}
          label={"ビルディングタイプ"}
          onClick={() =>
            setSelect(
              isBuildingType
                ? ArchitectureDropdown.None
                : ArchitectureDropdown.BuildingType,
            )
          }
        />
        <SearchDropdownButton
          active={isUseType}
          label={"空間用途"}
          onClick={() =>
            setSelect(
              isUseType
                ? ArchitectureDropdown.None
                : ArchitectureDropdown.UseType,
            )
          }
        />
        <SearchDropdownButton
          noarrow={true}
          active={false}
          label={"その他"}
          onClick={() => {
            closeHandler();
            onOpenModal();
          }}
        />
      </div>

      {select !== ArchitectureDropdown.None && (
        <div>
          {isBuildingType && (
            <EntityDrillDown<
              BuildingTypeResponse,
              ArchitectureSearchQueryParameter
            >
              entities={buildingTypes}
              watchQueryParameter={"building_type_id"}
              query={query}
              queryController={queryController}
              onReachedBottomEntity={closeHandler}
            />
          )}

          {isUseType && (
            <ul className="BorderList text-sm bg-white">
              {allUseTypes.map(({ id, name }) => {
                const path = queryController.toPath({
                  use_type_id: String(id),
                });

                return (
                  <li key={id}>
                    <DrillDownCell
                      name={name}
                      selected={id === parseInt(query.use_type_id, 10)}
                      hasArrow={true}
                      href={path}
                      onClick={closeHandler}
                    />
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};
export default SearchArchitectureDropdowns;
